<template>
  <ion-page>
    <ion-content>
      <bg :opaque="0"></bg>

      <form class="box-account" @submit="login">
        <div class="box-account-content">
          <div class="box-account-logo">
            <img src="../assets/svg/logo.svg">
          </div>
          <div v-if="error" class="box-account-error">{{ error }}</div>

          <div class="row">
            <div class="col">
              <input type="email" v-model="email" placeholder="User">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <input type="password" v-model="password" placeholder="Password">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <ion-button type="submit">Login</ion-button>
            </div>
          </div>
        </div>
      </form>

      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
export default {
  name: "Login",
  props: {
  },
  data: function() {
    return {
      loader: false,
      email: '',
      password: '',
      error: '',
    }
  },
  methods: {
    login(ev) {
      ev.preventDefault();
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/login', {
        email: this.email,
        password: this.password,
      })
      .then((response) => {
        let res = response.data;
        if(res.status == 0) {
          this.error = res.error;
        } else {
          this.$store.commit("setApiToken", res.data.api_token);
          this.$store.commit("setUserId", res.data.id);
          this.$store.commit("setUserName", res.data.name);
          this.$store.commit("setUserRole", res.data.role);
          this.$store.commit("setUserYachts", res.data.yachts);

          this.$router.push({name: 'home' });
        }
        this.loader = false;
      })
    }
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  width: 100px;
}

.box-account {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
}

.box-account-content {
  padding: 20px;
  line-height: 1;
  max-width: 500px;
  margin: 0 auto;
}

.box-account-logo {
  margin-bottom: 6%;
}

.box-account-logo img {
  height: 200px;
}

.box-account-error {
  color: var(--ion-color-primary);
  font-size: 14px;
  margin-bottom: 15px;
}

.box-account ion-button {
  font-size: 18px;
  height: 50px;
  width: 100%;
  margin: 0;
}

.box-account ion-button.button-clear {
  font-size: 16px;
  height: 50px;
}

ion-content {
  --padding-top: 0!important;
  /* --background: #fff url('../assets/svg/mockup.svg') no-repeat center center / cover; */
  --overflow: hidden;
}
</style>
